"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EthValueArgument = exports.EthStringArgument = exports.EthAddressArgument = void 0;
exports.createCallSource = createCallSource;
exports.createDynamicSource = createDynamicSource;
exports.createFeeSource = createFeeSource;
exports.createJsonSource = createJsonSource;
exports.createLiteralSource = createLiteralSource;
exports.createSenderSource = createSenderSource;
exports.createStepsSource = createStepsSource;
exports.getCallSourceParameters = getCallSourceParameters;
exports.getDynamicSourceParameters = getDynamicSourceParameters;
exports.getFeeSourceParameters = getFeeSourceParameters;
exports.getJsonSourceParameters = getJsonSourceParameters;
exports.getLiteralSourceParameters = getLiteralSourceParameters;
exports.getOtherSourceParameters = getOtherSourceParameters;
exports.getStepsSourceParameters = getStepsSourceParameters;
exports.getUniswapSourceParameters = getUniswapSourceParameters;
exports.isCallSource = isCallSource;
exports.isDynamicSource = isDynamicSource;
exports.isFeeSource = isFeeSource;
exports.isJsonSource = isJsonSource;
exports.isLiteralSource = isLiteralSource;
exports.isOtherSource = isOtherSource;
exports.isStepsSource = isStepsSource;
exports.isUniswapSource = isUniswapSource;
var _ethTypes = require("@blockwell/eth-types");
function isLiteralSource(source) {
  return (source === null || source === void 0 ? void 0 : source.type) === "literal";
}
function getLiteralSourceParameters(arg) {
  var _arg$value;
  if ((arg === null || arg === void 0 ? void 0 : (_arg$value = arg.value) === null || _arg$value === void 0 ? void 0 : _arg$value.type) === "literal") {
    return arg.value.parameters;
  }
  return null;
}
function isCallSource(source) {
  return (source === null || source === void 0 ? void 0 : source.type) === "call";
}
function getCallSourceParameters(arg) {
  var _arg$value2;
  if ((arg === null || arg === void 0 ? void 0 : (_arg$value2 = arg.value) === null || _arg$value2 === void 0 ? void 0 : _arg$value2.type) === "call") {
    return arg.value.parameters;
  }
  return null;
}
function isDynamicSource(source) {
  return (source === null || source === void 0 ? void 0 : source.type) === "dynamic";
}
function getDynamicSourceParameters(arg) {
  var _arg$value3;
  if ((arg === null || arg === void 0 ? void 0 : (_arg$value3 = arg.value) === null || _arg$value3 === void 0 ? void 0 : _arg$value3.type) === "dynamic") {
    return arg.value.parameters;
  }
  return null;
}
function isFeeSource(source) {
  return (source === null || source === void 0 ? void 0 : source.type) === "fee";
}
function getFeeSourceParameters(arg) {
  var _arg$value4;
  if ((arg === null || arg === void 0 ? void 0 : (_arg$value4 = arg.value) === null || _arg$value4 === void 0 ? void 0 : _arg$value4.type) === "fee") {
    return arg.value.parameters;
  }
  return null;
}
function isJsonSource(source) {
  return (source === null || source === void 0 ? void 0 : source.type) === "json";
}
function getJsonSourceParameters(arg) {
  var _arg$value5;
  if ((arg === null || arg === void 0 ? void 0 : (_arg$value5 = arg.value) === null || _arg$value5 === void 0 ? void 0 : _arg$value5.type) === "json") {
    return arg.value.parameters;
  }
  return null;
}
function isOtherSource(source) {
  return (source === null || source === void 0 ? void 0 : source.type) === "other";
}
function getOtherSourceParameters(arg) {
  var _arg$value6;
  if ((arg === null || arg === void 0 ? void 0 : (_arg$value6 = arg.value) === null || _arg$value6 === void 0 ? void 0 : _arg$value6.type) === "other") {
    return arg.value.parameters;
  }
  return null;
}
function isStepsSource(source) {
  return (source === null || source === void 0 ? void 0 : source.type) === "steps";
}
function getStepsSourceParameters(arg) {
  var _arg$value7;
  if ((arg === null || arg === void 0 ? void 0 : (_arg$value7 = arg.value) === null || _arg$value7 === void 0 ? void 0 : _arg$value7.type) === "steps") {
    return arg.value.parameters;
  }
  return null;
}
function isUniswapSource(source) {
  return (source === null || source === void 0 ? void 0 : source.type) === "uniswap";
}
function getUniswapSourceParameters(arg) {
  var _arg$value8;
  if ((arg === null || arg === void 0 ? void 0 : (_arg$value8 = arg.value) === null || _arg$value8 === void 0 ? void 0 : _arg$value8.type) === "uniswap") {
    return arg.value.parameters;
  }
  return null;
}
function createSource(type, parameters) {
  return {
    type,
    parameters: parameters
  };
}
function createLiteralSource(value) {
  return createSource("literal", {
    value
  });
}
function createDynamicSource(name) {
  return createSource("dynamic", {
    name
  });
}
function createCallSource(abi, address, args) {
  return createSource("call", {
    abi,
    address,
    arguments: args
  });
}
function createFeeSource(base, multiplier, ignoreDecimals) {
  let params = {
    base,
    multiplier
  };
  if (ignoreDecimals) {
    params.ignoreDecimals = true;
  }
  return createSource("fee", params);
}
function createJsonSource(json, mergeWith) {
  return createSource("json", {
    json,
    mergeWith
  });
}
function createSenderSource() {
  return createSource("other", {
    name: "sender"
  });
}

/**
 * @param step Step number, starting with 1.
 * @param name Name of the property from the step.
 */
function createStepsSource(step, name) {
  return createSource("steps", {
    step,
    name
  });
}
const EthValueArgument = exports.EthValueArgument = {
  type: "uint",
  typing: _ethTypes.Typing.uint,
  decimals: createLiteralSource(18)
};
const EthAddressArgument = exports.EthAddressArgument = {
  type: "address",
  typing: _ethTypes.Typing.address
};
const EthStringArgument = exports.EthStringArgument = {
  type: "string",
  typing: _ethTypes.Typing.string
};
//# sourceMappingURL=source-util.js.map